// OptionPriceDelta — part of the product option modal (ProductOptionView).
import Price from '@components/base/Price';

export default function OptionPriceDelta({ amount, className = 'option-price' }) {
  if (!amount) return null;

  const sign = amount < 0 ? '-' : '+';
  return (
    <span className={className}>
      {sign}
      <Price amount={Math.abs(amount)} />
    </span>
  );
}
